// prettier-ignore
export const AMAZON_ELIGIBLE_ZIP_CODES = new Set([
  // Connecticut
  "06042", "06489", "06706", "06757", "06801", "06880", "06907",
  // New Jersey
  "07006", "07014", "07016", "07032", "07044", "07055", "07063", "07072", "07073", "07079",
  "07094", "07310", "07403", "07444", "07450", "07470", "07503", "07508", "07512", "07604",
  "07645", "07656", "07657", "07675", "07719", "07727", "07728", "07738", "07747", "07764",
  "07834", "07836", "07960", "08012", "08071", "08215", "08226", "08701", "08724", "08742",
  "08755", "08807", "08861", "08873", "08876",
  // Military
  "09096", "09128",
  // New York
  "10001", "10002", "10009", "10012", "10018", "10019", "10022", "10024", "10027", "10036",
  "10538", "10562", "10601", "10950", "11021", "11023", "11201", "11205", "11206", "11209",
  "11211", "11213", "11215", "11220", "11225", "11226", "11231", "11232", "11235", "11249",
  "11378", "11550", "11558", "11735", "11743", "11747", "11753", "11803", "12065", "12305",
  "13790",
  // Pennsylvania
  "17057", "17078", "17601", "17602", "18045", "18067", "18640", "18643", "18707", "18944",
  "18966", "19040", "19116", "19119", "19120", "19127", "19128", "19129", "19150", "19355",
  "19382", "19422", "19440",
  // Delaware
  "19720", "19958", "19973",
  // DC
  "20001", "20007", "20011",
  // Maryland
  "20650", "20678", "20772", "20774", "20877", "21043", "21108", "21146", "21152", "21205",
  "21771",
  // Virginia
  "22030", "22033", "22039", "22150", "22304", "22310", "22401", "22602", "23005", "23060",
  "23224", "23236",
  // West Virginia
  "25701",
  // North Carolina
  "28105", "28117", "28203", "28206", "28209", "28217", "28226", "28273", "28277", "28602",
  "28806",
  // South Carolina
  "29072", "29206", "29605", "29620", "29649", "29732",
  // Georgia
  "30004", "30014", "30024", "30043", "30044", "30052", "30062", "30071", "30076", "30083",
  "30093", "30096", "30116", "30120", "30135", "30152", "30189", "30228", "30259", "30281",
  "30307", "30309", "30318", "30324", "30328", "30342", "30360", "30518", "30601", "30621",
  "30907", "30909", "31808", "31904",
  // Florida
  "32086", "32092", "32137", "32168", "32206", "32256", "32259", "32277", "32726", "32750",
  "32807", "32818", "32828", "32832", "32839", "32903", "32904", "32937", "32968", "33064",
  "33067", "33069", "33178", "33319", "33406", "33408", "33411", "33414", "33426", "33433",
  "33458", "33467", "33483", "33498", "33548", "33556", "33558", "33563", "33605", "33606",
  "33607", "33616", "33625", "33626", "33634", "33701", "33711", "33716", "33778", "33803",
  "33811", "33868", "33881", "33884", "33913", "33922", "34104", "34120", "34221", "34233",
  "34243", "34286", "34689", "34787", "34953", "34983", "34996",
  // Alabama
  "35094", "35124", "35203", "35216", "35501", "35660", "36830", "36832",
  // Tennessee
  "37013", "37034", "37042", "37067", "37122", "37135", "37206", "37211", "37404", "37405",
  "37416", "37849", "37874", "38351", "38464",
  // Kentucky
  "40065", "40165", "40213", "40223", "40229", "40342", "40444", "40503", "40511", "41056",
  "42301", "42501",
  // Ohio
  "43031", "43064", "43065", "43068", "43123", "43235", "43240", "43551", "43558", "44129",
  "44130", "44145", "44203", "44236", "44240", "44256", "44846", "45014", "45204", "45241",
  "45822", "45891",
  // Indiana
  "46077", "46131", "46168", "46237", "46241", "46250", "46256", "46530", "46706", "46803",
  "46809", "46814", "46818", "46975", "47130", "47150", "47546", "47909",
  // Michigan
  "48060", "48073", "48128", "48133", "48187", "48207", "48211", "48236", "48326", "48383",
  "48420", "48430", "48623", "48708", "48723", "48768", "49002", "49048", "49426", "49453",
  "49503", "49512",
  // Iowa
  "52246",
  // Wisconsin
  "53051", "53074", "53080", "53092", "53094", "53110", "53177", "53207", "54901",
  // Illinois
  "60005", "60007", "60018", "60025", "60035", "60053", "60056", "60090", "60110", "60126",
  "60173", "60174", "60175", "60181", "60191", "60302", "60433", "60467", "60503", "60516",
  "60586", "60603", "60605", "60607", "60611", "60622", "60640", "60641", "60642", "60644",
  "60654", "60661", "60707", "60957", "61244", "61254", "61354", "61526", "61726", "62510",
  // Missouri
  "64105", "64108", "64120", "64850", "65712", "65770", "65803",
  // Kansas
  "66207", "66215", "66219", "66223", "66286", "66503", "66801", "67226",
  // Nebraska
  "68123",
  // Oklahoma
  "73072",
  // Texas
  "75001", "75002", "75006", "75007", "75013", "75019", "75020", "75025", "75028", "75033",
  "75038", "75042", "75060", "75069", "75074", "75080", "75081", "75087", "75115", "75150",
  "75201", "75204", "75206", "75207", "75208", "75209", "75220", "75225", "75226", "75229",
  "75230", "75231", "75234", "75238", "75244", "75247", "75254", "75751", "75757", "76008",
  "76011", "76017", "76021", "76051", "76063", "76078", "76088", "76092", "76107", "76116",
  "76118", "76123", "76137", "76155", "76205", "76226", "76240", "76244", "76424", "77005",
  "77007", "77009", "77018", "77019", "77024", "77036", "77041", "77043", "77056", "77057",
  "77064", "77071", "77074", "77077", "77084", "77089", "77090", "77092", "77098", "77301",
  "77339", "77346", "77354", "77355", "77356", "77375", "77379", "77385", "77389", "77429",
  "77433", "77449", "77459", "77489", "77493", "77494", "77502", "77523", "77532", "77539",
  "77549", "77550", "77568", "77587", "77868", "77995", "78130", "78202", "78212", "78213",
  "78216", "78218", "78232", "78249", "78252", "78260", "78613", "78640", "78641", "78642",
  "78648", "78676", "78681", "78704", "78727", "78737", "78739", "78744", "78745", "78748",
  "79602",
  // Colorado
  "80002", "80010", "80011", "80026", "80030", "80033", "80110", "80130", "80134", "80162",
  "80204", "80207", "80211", "80216", "80220", "80221", "80223", "80231", "80301", "80302",
  "80401", "80504", "80513", "80516", "80540", "80907", "80915", "80917", "81008",
  // Wyoming
  "82001",
  // Arizona
  "85031", "85034", "85042", "85085", "85142", "85205", "85206", "85225", "85226", "85233",
  "85234", "85251", "85254", "85255", "85258", "85259", "85268", "85286", "85296", "85306",
  "85705", "85741",
  // Nevada
  "89081", "89113",
  // California
  "90001", "90007", "90011", "90012", "90013", "90014", "90015", "90016", "90019", "90021",
  "90022", "90023", "90026", "90027", "90031", "90036", "90037", "90038", "90040", "90041",
  "90043", "90046", "90048", "90049", "90058", "90059", "90061", "90063", "90064", "90065",
  "90066", "90077", "90210", "90255", "90260", "90266", "90272", "90277", "90292", "90293",
  "90301", "90401", "90402", "90403", "90405", "90501", "90502", "90621", "90631", "90640",
  "90660", "90670", "90680", "90703", "90723", "90745", "90746", "90755", "90803", "90806",
  "90808", "91001", "91010", "91105", "91107", "91201", "91203", "91304", "91307", "91311",
  "91321", "91325", "91342", "91350", "91355", "91356", "91361", "91362", "91367", "91406",
  "91504", "91601", "91604", "91605", "91606", "91702", "91706", "91710", "91724", "91730",
  "91732", "91733", "91748", "91752", "91761", "91766", "91768", "91776", "91780", "91789",
  "91911", "91950", "91978", "92008", "92010", "92011", "92014", "92021", "92024", "92026",
  "92037", "92058", "92064", "92071", "92078", "92081", "92101", "92102", "92104", "92108",
  "92109", "92113", "92117", "92121", "92126", "92130", "92131", "92154", "92243", "92316",
  "92335", "92346", "92354", "92392", "92408", "92501", "92503", "92507", "92518", "92532",
  "92551", "92606", "92614", "92618", "92626", "92627", "92630", "92647", "92649", "92651",
  "92653", "92663", "92672", "92673", "92677", "92688", "92701", "92704", "92705", "92806",
  "92821", "92831", "92843", "92845", "92870", "92879", "92882", "92887", "93001", "93003",
  "93013", "93105", "93108", "93117", "93551", "93720", "93725", "94030", "94086", "94087",
  "94089", "94102", "94107", "94110", "94114", "94115", "94122", "94123", "94124", "94133",
  "94134", "94401", "94403", "94515", "94538", "94549", "94577", "94582", "94587", "94588",
  "94608", "94610", "94611", "94612", "94618", "94931", "94952", "95030", "95035", "95037",
  "95060", "95215", "95476", "95650", "95682", "95758", "95816", "95818", "95834", "95841",
  "95945", "95973",
  // Oregon
  "97005", "97007", "97008", "97009", "97035", "97062", "97214", "97217", "97224", "97230",
  "97232",
  // Washington
  "98001", "98004", "98011", "98028", "98032", "98033", "98034", "98037", "98038", "98052",
  "98065", "98075", "98103", "98107", "98112", "98133", "98134", "98155", "98225", "98247",
  "98260", "98270", "98382", "98391", "98402", "98642", "98926",
]);

export function isAmazonEligibleZip(zipCode: string): boolean {
  const normalizedZip = zipCode.trim().substring(0, 5);
  return AMAZON_ELIGIBLE_ZIP_CODES.has(normalizedZip);
}
